<iframe class="mt-5" frameborder="0" border="0" cellspacing="0"
style="border-style: none;width: 100%; height: 700px;" id="iframe" src="../../assets/webgl_build/index.html"></iframe>
<p>Eikonikos peripatos works!</p>
<div #myimg>
</div>
<iframe allow="vr;accelerometer;gyroscope;fullscreen" frameborder="0" width="100%" height="1000" src="https://app.nocknock.io/show/WpS0CbOjy"></iframe>